import APP_ASSETS from "./assets";

export const SIDEBAR_ITEMS = [
  {
    name: "Wallet",
    logo: APP_ASSETS.ICONS.WALLET,
    routeURL: "wallet",
  },
  {
    name: "Stats",
    logo: APP_ASSETS.ICONS.STATS,
    routeURL: "stats",
  },
  {
    name: "Stake",
    logo: APP_ASSETS.ICONS.STAKE,
    routeURL: "stake",
  },
  {
    name: "Disputes",
    logo: APP_ASSETS.ICONS.DISPUTES,
    routeURL: "disputes",
  },
  {
    name: "Archived Orders",
    logo: APP_ASSETS.ICONS.ArchiveIcon,
    routeURL: "archived-orders",
  },
];

export const STEPS_TO_GET_STARTED = [
  "Copy the displayed wallet address.",
  "Join our Merchants telegram group using the button below.",
  "Post your in-app address in the “New Approvals” topic in the telegram group and contact an admin for verification to activate your merchant account.",
];

export const ALL_ORDER_TYPES = ["send", "receive"];

export const DUMMY_MONTHLY_VOLUME_STATS = [
  {
    month: "February 2024",
    volume: "79992.41",
  },
  {
    month: "January 2024",
    volume: "213424.62",
  },
  {
    month: "December 2023",
    volume: "97903.24",
  },
  {
    month: "November 2023",
    volume: "6921.53",
  },
  {
    month: "October 2023",
    volume: "0.00",
  },
  {
    month: "September 2023",
    volume: "0.00",
  },
  {
    month: "August 2023",
    volume: "0.00",
  },
  {
    month: "July 2023",
    volume: "0.00",
  },
  {
    month: "June 2023",
    volume: "0.00",
  },
  {
    month: "May 2023",
    volume: "0.00",
  },
  {
    month: "April 2023",
    volume: "0.00",
  },
  {
    month: "March 2023",
    volume: "0.00",
  },
];

export const DUMMY_PAST_ORDERS = [
  {
    status: "COMPLETE",
    amount: 4497.5,
    orderId: 1430,
    dateTime: "5/2 6:46 PM",
    transactionType: "send",
  },
  {
    status: "COMPLETE",
    amount: 6789.75,
    orderId: 1412,
    dateTime: "5/2 11:32 AM",
    transactionType: "receive",
  },
  {
    status: "COMPLETE",
    amount: 6779.25,
    orderId: 1397,
    dateTime: "4/2 9:39 PM",
    transactionType: "send",
  },
  {
    status: "COMPLETE",
    amount: 950.3325,
    orderId: 1375,
    dateTime: "4/2 10:45 AM",
    transactionType: "receive",
  },
  {
    status: "COMPLETE",
    amount: 4487.5,
    orderId: 1350,
    dateTime: "3/2 7:11 PM",
    transactionType: "send",
  },
  {
    status: "COMPLETE",
    amount: 89.94,
    orderId: 1331,
    dateTime: "3/2 1:03 PM",
    transactionType: "receive",
  },
  {
    status: "COMPLETE",
    amount: 18042,
    orderId: 1327,
    dateTime: "3/2 9:54 AM",
    transactionType: "send",
  },
  {
    status: "COMPLETE",
    amount: 4512,
    orderId: 1291,
    dateTime: "1/2 8:10 PM",
    transactionType: "receive",
  },
  {
    status: "COMPLETE",
    amount: 5000,
    orderId: 1280,
    dateTime: "1/2 6:00 PM",
    transactionType: "send",
  },
  {
    status: "COMPLETE",
    amount: 7500,
    orderId: 1270,
    dateTime: "1/2 4:30 PM",
    transactionType: "receive",
  },
  {
    status: "COMPLETE",
    amount: 6000,
    orderId: 1260,
    dateTime: "1/2 3:15 PM",
    transactionType: "send",
  },
  {
    status: "COMPLETE",
    amount: 7000,
    orderId: 1250,
    dateTime: "1/2 2:00 PM",
    transactionType: "receive",
  },
  {
    status: "COMPLETE",
    amount: 8000,
    orderId: 1240,
    dateTime: "1/2 12:45 PM",
    transactionType: "send",
  },
];

export const DUMMY_ACTIVE_ORDERS = [
  {
    status: "PENDING",
    amount: 4497.5,
    orderId: 1430,
    dateTime: "5/2 6:46 PM",
    transactionType: "send",
  },
  {
    status: "PENDING",
    amount: 6789.75,
    orderId: 1412,
    dateTime: "5/2 11:32 AM",
    transactionType: "receive",
  },
  {
    status: "PENDING",
    amount: 6779.25,
    orderId: 1397,
    dateTime: "4/2 9:39 PM",
    transactionType: "send",
  },
  {
    status: "PENDING",
    amount: 950.3325,
    orderId: 1375,
    dateTime: "4/2 10:45 AM",
    transactionType: "receive",
  },
  {
    status: "PENDING",
    amount: 4487.5,
    orderId: 1350,
    dateTime: "3/2 7:11 PM",
    transactionType: "send",
  },
];

export const LocalStorageKeys = {
  SAVED_WALLETS: "@P2PX:saved_address",
  SAVED_UPI: "@P2PX:saved_upi",
  PUBKEY: "@P2PX:pub_key",
  RELAY_IDENTITY: "@P2PX:relay_identity",
  LOGGED_IN: "@P2PX:isLoggedIn",
  MERCHANT_DETAILS: "@P2PX:merchant_details",
  ASSIGNED_ORDER_ID: "@P2PX:assigned_order_id",
  CONNECTED_WALLET_IDS: "thirdweb:connected-wallet-ids",
  MERCHANT_UPI: "@P2PME:merchant_upi",
  PRIVACY_POLICY_ACCEPTED: "@P2PX:privacy_policy_accepted",
  MERCH_BANK: "@P2PME:merch_bank",
};
